import { CSSProperties } from 'react';
import { ColorKey } from './pricingConfig';

export const PACK_SIZE = 50;

export const COLOR_LABELS: Record<ColorKey, string> = { negro: 'Negras', blanco: 'Blancas', azul: 'Azules', verde: 'Verdes', rojo: 'Rojas' };

export const bagColorStyle = (colorName: string): CSSProperties => {
  const color = String(colorName || '').toLowerCase();
  if (color.includes('negr')) return { color: '#111827', fill: '#111827' };
  if (color.includes('roj')) return { color: '#dc2626', fill: '#fecaca' };
  if (color.includes('verde')) return { color: '#16a34a', fill: '#bbf7d0' };
  if (color.includes('azul')) return { color: '#2563eb', fill: '#bfdbfe' };
  if (color.includes('amarill')) return { color: '#ca8a04', fill: '#fef08a' };
  if (color.includes('naranja')) return { color: '#ea580c', fill: '#fed7aa' };
  if (color.includes('blanc')) return { color: '#64748b', fill: '#ffffff' };
  if (color.includes('transparent')) return { color: '#0891b2', fill: '#cffafe' };
  return { color: '#64748b', fill: '#e2e8f0' };
};

export const receiptColorStyle = (colorName: string): CSSProperties => {
  const color = String(colorName || '').toLowerCase();
  if (color.includes('negr')) return { backgroundColor: '#111827', color: '#fff' };
  if (color.includes('roj')) return { backgroundColor: '#fee2e2', color: '#991b1b' };
  if (color.includes('verde')) return { backgroundColor: '#dcfce7', color: '#166534' };
  if (color.includes('azul')) return { backgroundColor: '#dbeafe', color: '#1e40af' };
  if (color.includes('amarill')) return { backgroundColor: '#fef9c3', color: '#854d0e' };
  if (color.includes('naranja')) return { backgroundColor: '#ffedd5', color: '#9a3412' };
  if (color.includes('blanc')) return { backgroundColor: '#fff', color: '#111827', boxShadow: 'inset 0 0 0 1px #d1d5db' };
  return { backgroundColor: '#ecfeff', color: '#155e75' };
};
